import React from 'react';
import PropTypes from 'prop-types';
import './LogoutConfirmationPopup.css';
import { useTranslation } from 'react-i18next';

const LogoutConfirmationPopup = ({ isOpen, onConfirm, onClose }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="lo-ovl">
      <div className="lo-mdl">
        <button className="lo-close" onClick={onClose} aria-label="Close" data-tooltip-id="global-tooltip" data-tooltip-content={t("Close")}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div className="lo-body">
          <div className="lo-hdr">
            <span className="lo-icn">⚠️</span>
            <h2 className="lo-ttl">{t('Confirm Log Out')}</h2>
          </div>
          <p className="lo-msg">
            {t('Are you sure you want to log out? You\'ll need to sign in again to access your account.')}
          </p>
          <div className="lo-acts">
            <button className="lo-btn lo-btn-pri" onClick={onClose}>
              {t('Stay Logged In')}
            </button>
            <button className="lo-btn lo-btn-sec" onClick={onConfirm}>
              {t('Logout')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

LogoutConfirmationPopup.propTypes = {
  isOpen: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
};

export default LogoutConfirmationPopup;